jQuery(document).ready(function($) {
  let reviewsIndex = 0
  const reviewsSlides = $('.reviews_slider .hidden')

  const getNextIndex = (index) => {
    return index == reviewsSlides.length-1 ? 0 : index+1
  }

  const getPrviousIndex = (index) => {
    return index==0 ? reviewsSlides.length-1 : index-1
  }

  function sliderAnimation() {
    gsap.to('.reviews_slider .slide.main', {
      opacity: 0,
      duration: .3,
      onComplete: () => {
        $('.reviews_slider .slide.main').children('.review').html(
          $(reviewsSlides[reviewsIndex]).children('.review').html()
        )

        $('.reviews_slider .slide.main').children('.author').text(
          $(reviewsSlides[reviewsIndex]).children('.author').text()
        )
        
        gsap.to('.reviews_slider .slide.main', {
          opacity: 1,
          duration: .3,
        })
      } 
    })
  
    gsap.to('.reviews_slider', {
      height: $(reviewsSlides[reviewsIndex]).innerHeight(),
      duration: .5,
      ease: 'power1.out',
    })
  }

  $('.reviews .slider-prev').on('click', ()=>{
    reviewsIndex = getPrviousIndex(reviewsIndex)

    sliderAnimation()
  })

  $('.reviews .slider-next').on('click', ()=>{
    reviewsIndex = getNextIndex(reviewsIndex)

    sliderAnimation()
  })
  
  const handleSliderHeight = ()=>{
    $('.reviews_slider').css('height', $(reviewsSlides[reviewsIndex]).innerHeight())
  }

  handleSliderHeight()
  $(window).on('resize', handleSliderHeight)
})